import { Dispatch } from "redux";
import { activeClaimsApi, activeIntimationsApi, beneficiariesApi, fetchClaimListDatas } from "../../api/claim";
import { IEnrolmentReqPayload, beneficiaryReqPayload, VendorDetailsPayload, VendorUrlPayload, FlexPolicyRequestDTO } from "../../modules/home/home.model";
import { ActionType } from "../action-type/index";
import { corporate_config_Res, flex_polices_Res, HealthBenefits_Res, healthPatnerServices_Res, IActiveCalim_Res, IActiveIntimation_Res, IBenefRes, Ienrolment_Res, vendor_url_Res } from "../interface/homeInterface";
import { fetch_Api_Details_Fail, fetch_Api_Details_Start } from "./commonAction";
import { enrolmentsApi } from "../../api/member";
import { ClaimListDetails, ClaimListRequest, ClaimListResponse } from "../../modules/claim/models/claimList.models";
import { healthBenefitsApi, healthCheckPartnerServices, vendorlUrlApi } from "../../api/opd";
import { fetchCorporateConfig, fetchFlexPolicies } from "../../api/profile";
const reduxRefreshTime = Number(20 * 60 * 1000);

const fetchBeneficiariesDetailsSuccess = (benefResData, policyResData): IBenefRes => ({
    type: ActionType.FETCH_BENEFICIARY_DETAILS_SUCCESS,
    beneficiaryDetails: benefResData,
    policyDetails: policyResData,
    timeStamp: Date.now() + reduxRefreshTime,
})

export const fetch_Beneficiaries_And_Policy_Details = (req_payload: beneficiaryReqPayload) => {
    return (dispatch: Dispatch<IBenefRes>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_BENEFICIARY_DETAILS_START));
        beneficiariesApi().then((response) => {
            if (response && response?.beneficiaries?.length >0 ) {
                dispatch(fetchBeneficiariesDetailsSuccess(response.beneficiaries, response.policies));
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_BENEFICIARY_DETAILS_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_BENEFICIARY_DETAILS_FAIL, error.message));
        })
    }
}

export const fetch_ActiveCalims_Details = () => {
    return (dispatch: Dispatch<IActiveCalim_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_ACTIVECLAIM_DETAILS_START));
        activeClaimsApi().then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_ACTIVECLAIM_DETAILS_SUCCESS,
                    claims: response.claims ?? [],
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            };
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ACTIVECLAIM_DETAILS_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ACTIVECLAIM_DETAILS_FAIL, error.message));
        })
    }
}

export const fetch_ActiveIntimations_Details = () => {
    return (dispatch: Dispatch<IActiveIntimation_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_ACTIVECINTIMATION_DETAILS_START));
        activeIntimationsApi().then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_ACTIVECINTIMATION_DETAILS_SUCCESS,
                    intimations: response.intimations ?? [],
                    timeStamp: Date.now() + reduxRefreshTime,
                });
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ACTIVECINTIMATION_DETAILS_FAIL, response.error));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ACTIVECINTIMATION_DETAILS_FAIL, error.message));
        })
    }
}
export const fetch_Enrolments_Details = (req_payload: IEnrolmentReqPayload) => {
    return (dispatch: Dispatch<Ienrolment_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_ENROLMENT_DETAILS_START));
        enrolmentsApi(req_payload).then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_ENROLMENT_DETAILS_SUCCESS,
                    enrolments: response,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ENROLMENT_DETAILS_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_ENROLMENT_DETAILS_FAIL, error.message));
        })
    }
}

export const fetch_Health_Benefits = () => {
    return (dispatch: Dispatch<HealthBenefits_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_HEALTH_BENEFITS_START));
        healthBenefitsApi().then((response) => {
            if (response && response.isSuccess) {
                dispatch({
                    type: ActionType.FETCH_HEALTH_BENEFITS_SUCCESS,
                    healthBenefits: response,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_HEALTH_BENEFITS_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_HEALTH_BENEFITS_FAIL, error.message));
        })
    }
}

export const fetch_Health_Check_Partner = (req_payload: VendorDetailsPayload) => {
    return (dispatch: Dispatch<healthPatnerServices_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_HEALTH_HEALTH_CHECK_PARTNER_START));
        healthCheckPartnerServices(req_payload).then((response) => {
            if (response) {
                dispatch({
                    type: ActionType.FETCH_HEALTH_CHECK_PARTNER_SUCCESS,
                    healthCheckPartnerServices: response,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_HEALTH_CHECK_PARTNER_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_HEALTH_CHECK_PARTNER_FAIL, error.message));
        })
    }
}

export const fetch_Vendor_Url = (req_payload: VendorUrlPayload) => {
    return (dispatch: Dispatch<vendor_url_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_VENDOR_URL_START));
        vendorlUrlApi(req_payload).then((response) => {
            if (response) {
                dispatch({
                    type: ActionType.FETCH_VENDOR_URL_SUCCESS,
                    vendorUrls: response,
                    vendorId: req_payload.vendorId,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_VENDOR_URL_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_VENDOR_URL_FAIL, error.message));
        })
    }
}

export const fetch_Flex_Policies = () => {
    return (dispatch: Dispatch<flex_polices_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_FLEX_POLICIES_START));
        fetchFlexPolicies().then((response) => {
            if (response && response.isSuccess && response.flexDetails && response.flexDetails.length) {
                dispatch({
                    type: ActionType.FETCH_FLEX_POLCIES_SUCCESS,
                    flexPolicies: response.flexDetails,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (response && (!response.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_FLEX_POLCIES_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_FLEX_POLCIES_FAIL, error.message));
        })
    }
}

export const fetch_Corporate_Config = () => {
    return (dispatch: Dispatch<corporate_config_Res>) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_CORPORATE_CONFIG_START));
        fetchCorporateConfig().then((response) => {
            if (response && response.isSuccess && response.corporateConfig) {
                dispatch({
                    type: ActionType.FETCH_CORPORATE_CONFIG_SUCCESS,
                    corporateConfig: response.corporateConfig,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
            }
            if (!response || !response.isSuccess) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_CORPORATE_CONFIG_FAIL, response.error || response.message));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_CORPORATE_CONFIG_FAIL, error.message));
        })
    }
}